/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCompanyGsvResponse
 */
export interface ClientCompanyGsvResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyGsvResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyGsvResponse
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ClientCompanyGsvResponse
     */
    totalGsvSpent: number;
}

/**
 * Check if a given object implements the ClientCompanyGsvResponse interface.
 */
export function instanceOfClientCompanyGsvResponse(value: object): value is ClientCompanyGsvResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('totalGsvSpent' in value) || value['totalGsvSpent'] === undefined) return false;
    return true;
}

export function ClientCompanyGsvResponseFromJSON(json: any): ClientCompanyGsvResponse {
    return ClientCompanyGsvResponseFromJSONTyped(json, false);
}

export function ClientCompanyGsvResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyGsvResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'totalGsvSpent': json['totalGsvSpent'],
    };
}

export function ClientCompanyGsvResponseToJSON(value?: ClientCompanyGsvResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'totalGsvSpent': value['totalGsvSpent'],
    };
}

